import { TrashIcon } from 'lucide-react';

import { Button } from 'components/ui/button';
import type { TotadminPermission } from 'data/__generated__';

type TotemTrashButtonProps = {
    onClick: () => void;
    disabled?: boolean;
    /** Droits fins TOUS requis. Sans eux : grisé + cadenas (cf. `Button`). */
    requiredPermissions?: readonly TotadminPermission[];
};

export function TotemTrashButton({ onClick, disabled, requiredPermissions }: TotemTrashButtonProps) {
    return (
        <Button
            type="button"
            variant="destructive"
            size="icon-sm"
            onClick={onClick}
            disabled={disabled}
            requiredPermissions={requiredPermissions}
        >
            <TrashIcon />
        </Button>
    );
}
